// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

ion-card {
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

ion-card-content {
  flex: 1;
  min-height: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/charts/bar-chart/bar-chart.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;AACF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\nion-card {\n  height: 100%;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n}\n\nion-card-content {\n  flex: 1;\n  min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
